export default __webpack_public_path__ + "static/media/key_features_easy_management.7a39af1f.svg";